import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TPhoneFieldsProps } from './models';
import { PhoneField as Component } from './phone-field';

export const PhoneField = createWidget<unknown, TPhoneFieldsProps>()(Component);
